import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdvertising = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.00009 5.99988H3.92004C2.85963 5.99988 2 6.85951 2 7.91992V10.48C2 11.5404 2.85963 12.4 3.92004 12.4H6.00009M6.00009 5.99988L13.4586 3.28771C14.1107 3.05055 14.8003 3.53354 14.8003 4.2275V14.1724C14.8003 14.8664 14.1107 15.3494 13.4586 15.1122L6.00009 12.4M6.00009 5.99988V12.4M6.00064 17.2L3.60059 12.3999M14.7998 5.99976C16.6961 6.26643 17.9999 7.33312 17.9999 9.19983C17.9999 11.0665 16.6961 12.1332 14.7998 12.3999V5.99976Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAdvertising;
